// components/buttons/SubmitButton.js
import React from 'react';
import { TouchableOpacity, Text, StyleSheet } from 'react-native';
import {useCurrentTheme} from "@/theming/useCurrentTheme";
import {ButtonProps} from "@/components/form/ButtonProps";
import {ThemeType} from "@/theming/baseTheme";

export const SubmitButton = ({
                                 onPress,
                                 title,
                                 loading = false,
                                 disabled = false,
                                 style,
                                 textStyle,
                                 ...props
                             }: ButtonProps) => {
    const { theme } = useCurrentTheme();
    const styles = createStyles(theme);

    const isDisabled = disabled || loading;

    return (
        <TouchableOpacity
            style={[
                styles.button,
                isDisabled && styles.buttonDisabled,
                style
            ]}
            onPress={onPress}
            disabled={isDisabled}
            {...props}
        >
            <Text style={[styles.buttonText, textStyle]}>
                {loading ? `${title}...` : title}
            </Text>
        </TouchableOpacity>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    button: {
        backgroundColor: theme.colors.primary,
        padding: theme.spacing.md,
        borderRadius: theme.borderRadius.md,
        alignItems: 'center',
        marginBottom: theme.spacing.md,
    },
    buttonDisabled: {
        backgroundColor: theme.colors.textSecondary,
        opacity: 0.6,
    },
    buttonText: {
        color: theme.colors.background,
        fontSize: theme.fontSize.md,
        fontWeight: 'bold',
    },
});
